import loanClient from "services/httpClient/loanClient";
import { ActiveLoans, ApiResponse, RequestLoan } from "styles/types/loans";
import {
  LoanHistoryResponse,
  LoanKeyFacts,
  LoanLiquidationPayload,
  MonthlyRepaymentResponse,
} from "./models";

export const getAllLoans = () => {
  return loanClient.get("/api/Loan");
};

export const getLoanHistory = (pageNumber: number = 1, pageSize = 10) => {
  return loanClient.get<LoanHistoryResponse>(
    `/api/Loan/loan-history?PageNumber=${pageNumber}&PageSize=${pageSize}`
  );
};

// Just incase we need it to come through.
export const getActiveLoan = (
  pageNumber: number = 1,
  pageSize: number = 100
) => {
  return loanClient.get<ApiResponse<ActiveLoans>>(
    `/api/Loan/active-loan?pageNumber=${pageNumber}&pageSize=${pageSize}`
  );
};

export const getLoanActivity = () => {
  return loanClient.get("/api/Loan/loan-activity");
};

export const requestLoan = (payload: RequestLoan) => {
  return loanClient.post("/api/Loan/request-loan", payload);
};

export const liquidateLoan = (payload: LoanLiquidationPayload) => {
  return loanClient.post("/api/Loan/liquidation", payload);
};

export const getLoanRepayment = (loanReference: string) => {
  return loanClient.get<MonthlyRepaymentResponse>(
    `/api/Loan/repayment-schedule/${loanReference}`
  );
};

export const getAllSalariedLoans = () => {
  return loanClient.get("/api/Loan/salaried-loan");
};

export const loanKeyFacts = async (
  Amount: number,
  LoanTenor: number,
  loanType: string
) => {
  const payload = {
    Amount,
    LoanTenor,
    LoanType: loanType
  };
  const res = await loanClient.post<LoanKeyFacts>(
    "/api/Loan/loan-key-facts",
    payload
  );
  return res.data?.Data;
};

// function getLoanType(loanType: string) {
//   switch (loanType) {
//     case "PayDay":
//       return 0;
//     case "SalaryAdvance":
//       return 1;
//     case "SmallTicketPersonalLoan":
//       return 2;
//     case "DeviceFinance":
//       return 3;
//     case "VehicleFinance":
//       return 4;
//     // case "Mortgage":
//     //   return 5;
//     case "InstantBusinessLoan":
//       return 5;
//     // case "AccessAgentLending":
//     //   return 7;
//     case "Paylater":
//       return 6;
//     case "Lato":
//       return 7;
//     default:
//       return 0;
//   }
// }
